import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { TEXT_CREATED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { duplicateActiveWidgets } from 'modules/Editor/Editor.helpers';
import { RootState, useAppSelector, useAppStore } from 'modules/Editor/store';
import { selectWidgets } from 'modules/Editor/store/infographSelector';
import { selectActiveWidgets, selectHasActiveWidget } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { useTranslation } from 'react-i18next';
import { WidgetType } from 'types/widget.types';
import { TextWidgetData } from 'widgets/TextBasedWidgets/TextWidget/TextWidget.types';
import { getWidgetTypeFromId } from 'widgets/Widget.helpers';

export const DuplicateMenu = () => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const appStore = useAppStore();

  const isDisabled = !useAppSelector(selectHasActiveWidget);
  const label = t('duplicate');

  const onDuplicate = () => {
    const state = appStore.getState() as RootState;

    // we only need to access these values when onDuplicate is called (no useAppSelector subscription needed)
    const activeWidgets = selectActiveWidgets(state);
    const widgets = selectWidgets(state);

    duplicateActiveWidgets();

    if (!activeWidgets[1] && activeWidgets[0]?.id) {
      const widgetType = getWidgetTypeFromId(activeWidgets[0]?.id);
      if (widgetType === WidgetType.Text) {
        const { textTag } = widgets[activeWidgets[0]?.id] as TextWidgetData;
        const textType = textTag || 'Other';

        Mixpanel.track(TEXT_CREATED.eventName, {
          from: TEXT_CREATED.from.Duplication,
          text_style: textType.replace(textType[0], textType[0].toUpperCase()),
        });
      }
    }
  };

  return (
    <Tooltip
      hasArrow
      placement='bottom'
      label={
        <>
          {label} <Keyboard shortcut={['ctrl', 'D']} macOs={['⌘', 'D']} />
        </>
      }
      bg='black'
    >
      <IconButton
        isDisabled={isDisabled}
        size='sm'
        variant={'ghost-with-active'}
        aria-label={label}
        icon={<DuplicateIcon />}
        onClick={onDuplicate}
      />
    </Tooltip>
  );
};
